import { UUID } from '@/api/generatedApi';
import { useGetAsset } from '@/hooks/api/assets/useGetAsset';
import { Box, Divider } from '@mui/material';
import { AssetActionRow } from '../AssetActionRow';
import { LeftPanel } from '../DraggablePanel/LeftPanel';
import { AssetDetails } from './AssetDetails';
import { AssetMetadata } from './AssetMetadata';
import { ComparePageObjectModel } from '@/poms/comparePageObjectModel';
import { MatchPercentageDisplay } from './MatchPercentageDisplay';
import { MatchData } from '@/types/matchData';
import { BodyText } from '@/components/BodyText';
import { HelpIcon } from '../HelpContent/HelpIcon';
import CompareIcon from '@mui/icons-material/Compare';

export const CompareSidebar = ({
  asset1Id,
  asset2Id,
  asset1TenantId,
  asset2TenantId,
  onWidthChange,
  matchData,
}: {
  asset1Id?: UUID;
  asset2Id?: UUID;
  asset1TenantId?: UUID;
  asset2TenantId?: UUID;
  onWidthChange?: (width: number) => void;
  matchData?: MatchData;
}) => {
  const { asset: asset1 } = useGetAsset({ assetId: asset1Id, assetTenantId: asset1TenantId });
  const { asset: asset2 } = useGetAsset({ assetId: asset2Id, assetTenantId: asset2TenantId ?? asset1TenantId });

  return (
    <LeftPanel
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
      }}
      onWidthChange={onWidthChange}
      data-testid={ComparePageObjectModel.CompareSidebar}
    >
      <MatchPercentageDisplay matchData={matchData} asset1={asset1} asset2={asset2} />
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <></>
        {asset1 ? (
          <>
            <AssetActionRow asset={asset1} />
            <Box sx={{ height: 'calc(100% - 56px)', overflowY: 'auto' }}>
              <AssetDetails asset={asset1} />
              <AssetMetadata asset={asset1} />
            </Box>
          </>
        ) : (
          <EmptyCompare />
        )}
      </Box>
      <Divider />
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        {asset2 ? (
          <>
            <AssetActionRow asset={asset2} />
            <Box sx={{ height: 'calc(100% - 56px)', overflowY: 'auto' }}>
              <AssetDetails asset={asset2} />
              <AssetMetadata asset={asset2} />
            </Box>
          </>
        ) : (
          <EmptyCompare />
        )}
      </Box>
    </LeftPanel>
  );
};

const EmptyCompare = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '24px' }}>
      <BodyText component='p' sx={{ textAlign: 'center', color: 'text.secondary' }}>
        Click{' '}
        <HelpIcon>
          <CompareIcon sx={{ fontSize: '16px' }} />
        </HelpIcon>{' '}
        to compare
      </BodyText>
    </Box>
  );
};
